import request from '@/utils/request'

let LateralApi = {
    /*列表*/
    getProduct(data) {
        return request._get('/shop/plus.lateral.product/index', data);
    },
    /*添加*/
    addProduct(data) {
        return request._post('/shop/plus.lateral.product/add', data);
    },
    /*编辑*/
    editProduct(data) {
        return request._post('/shop/plus.lateral.product/edit', data);
    },
    /*删除*/
    delProduct(data) {
        return request._post('/shop/plus.lateral.product/delete', data);
    },
    /*获取设置*/
    getSetting(data) {
        return request._get('/shop/plus.lateral.setting/index', data);
    },
    /*保存设置*/
    saveSetting(data) {
        return request._post('/shop/plus.lateral.setting/index', data);
    },

}

export default LateralApi;



// WEBPACK FOOTER //
// ./src/api/lateral.js